import { render, staticRenderFns } from "./HeaderPrintReportRevenue.vue?vue&type=template&id=c56f6b3a&"
import script from "./HeaderPrintReportRevenue.vue?vue&type=script&lang=js&"
export * from "./HeaderPrintReportRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports